import showEdit from './edit.vue'
import showList from './list.vue'
import * as showcategoryList from './category'

let a = Object.assign({ showEdit, showList}, showcategoryList)
export default a;